<style scoped>
.togs_of {
  margin: 0px;
  text-align: center;
  text-transform: capitalize;
}
.community_chanel {
  text-transform: uppercase;
  text-align: center;
  margin: 0px;
}
.humtog_s {
  margin-bottom: 27px;
}
.comtt_c {
  border-left: none !important;
}
.community_togs {
  padding-left: 15px !important;
  list-style-type: none;
}
</style>
<template>
  <div class="sidebar-right comtt_c" :class="theme">
    <el-card class="box-card humtog_s">
      <h2 class="community_chanel">TBC</h2>
      <p>This box needs to be replaced with the channels's intro box.</p>
    </el-card>
    <el-card class="box-card humtog_s">
      <h2 class="togs_of">Togs of India</h2>
      <p>An unordered list:</p>
      <ul class="community_togs">
        <li>Coffee</li>
        <li>Tea</li>
        <li>Milk</li>
      </ul>
    </el-card>
  </div>
</template>

<script>
import Helpers from "../../mixins/Helpers";
import Tour from "../../components/Tour";

export default {
  mixins: [Helpers],

  components: { Tour },

  data() {
    return {
      subscribedFilter: "",
      showMenu: false,
      showSubMenu: false
    };
  },

  watch: {
    $route: function() {
      this.subscribedFilter = "";
    },

    showMenu() {
      if (this.showMenu === false) {
        this.showSubMenu = false;
      }
    }
  },

  computed: {
    showLoadMoreChannels() {
      return (
        this.channels.length > this.channelsLimit && !this.subscribedFilter
      );
    },

    showDiscoverChannels() {
      return (
        this.channels.length < this.channelsLimit &&
        !this.subscribedFilter &&
        Store.settings.rightSidebar.channelsFilter == "subscribed"
      );
    },

    channels() {
      if (this.filter == "bookmarked") {
        return Store.state.bookmarkedChannels;
      }

      if (this.filter == "moderating") {
        return Store.state.moderatingChannels;
      }

      // subscribed
      return Store.state.subscribedChannels;
    },

    channelsCount() {
      return this.channels.length;
    },

    showChannelAvatars() {
      return Store.settings.rightSidebar.showChannelAvatars;
    },

    channelsLimit() {
      return Store.settings.rightSidebar.channelsLimit;
    },

    theme() {
      if (!this.showTour) {
        return (
          "theme-" +
          this.str_slug(Store.settings.rightSidebar.color) +
          " overflow-hidden"
        );
      }

      return "theme-" + this.str_slug(Store.settings.rightSidebar.color);
    },

    filter() {
      return Store.settings.rightSidebar.channelsFilter;
    },

    filterForHumans() {
      if (this.filter == "subscribed") return "Subscribed Channels";

      if (this.filter == "bookmarked") return "Bookmarked Channels";

      if (this.filter == "moderating") return "Moderating Channels";
    },

    sortedSubscribeds() {
      let self = this;

      return _.orderBy(
        self.channels.filter(
          channel =>
            channel.name
              .toLowerCase()
              .indexOf(self.subscribedFilter.toLowerCase()) !== -1
        ),
        "subscribers_count",
        "desc"
      ).slice(0, self.channelsLimit > 2 ? self.channelsLimit : 2);
    }
  },

  created() {
    this.$eventHub.$on("pressed-esc", this.closeMenu);
  },

  methods: {
    closeMenu() {
      this.showMenu = false;
    },

    moreChannels() {
      Store.settings.rightSidebar.channelsLimit += 15;
    },

    pushToDiscoverChannels() {
      this.$router.push({ name: "discover-channels" });
    },

    lessChannels() {
      Store.settings.rightSidebar.channelsLimit -= 15;
    },

    signOut() {
      this.$confirm(
        `Are you sure about signing out of your account?`,
        "Confirm",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "Never mind",
          type: "warning"
        }
      )
        .then(() => {
          Vue.clearLS();

          axios
            .post("/logout")
            .then(() => {
              window.location = "/";
            })
            .catch(() => {
              this.$message({
                message: "Something went wrong.",
                type: "error"
              });
            });
        })
        .catch(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/auth/NewRightSidebar.vue